/* PhoneMatter intent core: remembers who the visitor is shopping for and the look they like (this browser only), and scores cases against it.
   Used by the finder sheet (pm-intent.js) and the home page top picks (pm-home.js). Small on purpose: it loads on every page. */
(function () {
  'use strict';
  if (window.pmIntent) return;
  var KEY = 'pm_intent', MODEL_KEY = 'user_selected_device_model';

  var VIBES = [
    ['minimal', 'Clean & minimal'],
    ['cute', 'Cute & playful'],
    ['bold', 'Bold & colourful'],
    ['rugged', 'Rugged protection'],
    ['luxe', 'Luxe & leather']
  ];
  /* what each look means in this catalogue (tags first, then words in the title) */
  var VIBE_TAGS = {
    minimal: ['clear', 'transparent', 'matte', 'slim', 'frosted', 'glass'],
    cute: ['cute', 'floral', 'pastel', 'aesthetic', 'botanical', 'furry'],
    bold: ['gradient', 'glitter', 'holographic', 'iridescent', 'neon', 'chrome', 'sparkle', 'rhinestone', 'glossy'],
    rugged: ['shockproof', 'armor', 'rugged', 'shock', 'drop', 'carbon', 'kickstand', 'stand'],
    luxe: ['leather', 'metal', 'pearl', 'rhinestone', 'chrome']
  };
  var VIBE_WORDS = {
    minimal: ['clear', 'crystal', 'frosted', 'slim', 'minimal'],
    cute: ['bear', 'bunny', 'kitty', 'cat', 'heart', 'bow', 'bowknot', 'strawberry', 'flower', 'melody', 'cartoon', 'puppy', 'fluffy', 'furry'],
    bold: ['holographic', 'glitter', 'neon', 'gradient', 'star', 'sparkle', 'rainbow'],
    rugged: ['armor', 'rugged', 'carbon', 'shockproof', 'bumper', 'kickstand', 'tactical'],
    luxe: ['leather', 'pearl', 'metal', 'luxury', 'electroplated', 'rose']
  };
  var HER_TAGS = ['cute', 'floral', 'pastel', 'rhinestone', 'glitter', 'sparkle', 'holographic', 'iridescent', 'aesthetic', 'botanical', 'furry'];
  var HER_WORDS = ['bow', 'bowknot', 'bunny', 'heart', 'pearl', 'beaded', 'chain', 'furry', 'fluffy', 'flower', 'kitty', 'bear', 'strawberry', 'melody', 'crossbody', 'rose', 'pink', 'cat', 'lip', 'lanyard'];
  var HIM_TAGS = ['carbon', 'rugged', 'armor', 'kickstand', 'metal'];
  var HIM_WORDS = ['carbon', 'armor', 'rugged', 'metal', 'tactical', 'bumper', 'sport', 'steel'];

  var PHONES = ['iPhone Duo', 'iPhone 18 Pro Max', 'iPhone 18 Pro', 'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16', 'iPhone 15 Pro Max', 'iPhone 15'];

  function read(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { e = 0; } }

  function get() {
    var s = read(KEY) || {};
    return { who: s.who || null, vibes: s.vibes || [], ts: s.ts || 0 };
  }
  function set(p) {
    var cur = get();
    var next = { who: p.who !== undefined ? p.who : cur.who, vibes: p.vibes !== undefined ? p.vibes : cur.vibes, ts: Date.now() };
    write(KEY, next);
    try { document.dispatchEvent(new CustomEvent('pm-intent', { detail: next })); } catch (e) { e = 0; }
    return next;
  }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) { e = 0; } try { document.dispatchEvent(new CustomEvent('pm-intent', { detail: get() })); } catch (e2) { e2 = 0; } }
  function has() { var s = get(); return !!(s.who || s.vibes.length); }

  function phone() {
    var m = '';
    try { m = (localStorage.getItem(MODEL_KEY) || '').trim(); } catch (e) { m = ''; }
    return /iphone/i.test(m) ? m.replace(/iphone/ig, 'iPhone') : '';
  }
  function slug(m) { return String(m).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '-cases'; }

  function words(title) { return String(title || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/); }
  function hits(list, tags, w) {
    var n = 0;
    list.forEach(function (x) { if (tags.indexOf(x) > -1) n++; });
    return n;
  }
  /* the audience tag you put on a case: audience-her, audience-him or audience-all (near spellings such as audiencer-her also count). It beats anything guessed. */
  function aud(p) {
    var her = false, him = false, all = false;
    (p.tags || []).forEach(function (t) {
      var x = String(t).toLowerCase().replace(/[\s_]+/g, '-');
      if (/^(audience[a-z]*|for)-(her|women|womens|woman|female|girl|girls|ladies)$/.test(x)) her = true;
      else if (/^(audience[a-z]*|for)-(him|men|mens|man|male|boy|boys)$/.test(x)) him = true;
      else if (/^audience[a-z]*-(all|unisex|everyone|any)$/.test(x)) all = true;
    });
    if ((her && him) || all) return 'all';
    return her ? 'her' : him ? 'him' : null;
  }
  /* audience leaning of a case: positive = her, negative = him (a tag is +-6, a guess from tags and title words is at most +-3) */
  function lean(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); }), w = words(p.title);
    var a = aud(p); if (a === 'her') return 6; if (a === 'him') return -6; if (a === 'all') return 0;
    var her = hits(HER_TAGS, tags) + hits(HER_WORDS, w), him = hits(HIM_TAGS, tags) + hits(HIM_WORDS, w);
    return Math.max(-3, Math.min(3, her - him));
  }
  function vibeHit(p, v) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); }), w = words(p.title);
    return hits(VIBE_TAGS[v] || [], tags) + hits(VIBE_WORDS[v] || [], w);
  }
  /* one number per case: higher shows first */
  function score(p, rank) {
    var s = get(), n = 0, l = lean(p), tagged = aud(p);
    if (tagged === 'all' && (s.who === 'her' || s.who === 'him')) n += 2;
    else if (tagged === 'all' && s.who === 'gift') n += 4;
    else if (s.who === 'her') n += l > 0 ? 1 + l : (l < 0 ? -1 + l : 0);
    else if (s.who === 'him') n += l < 0 ? 1 - l : (l > 0 ? -1 - l : 0);
    else if (s.who === 'gift') n += (l === 0 ? 1.5 : 0.5);
    s.vibes.forEach(function (v) { var h = vibeHit(p, v); if (h) n += 2 + Math.min(h - 1, 2) * 0.5; });
    return Math.round((n + (rank == null ? 0 : Math.max(0, 5 - rank * 0.05))) * 100) / 100;
  }
  function why(p) {
    var s = get(), l = lean(p);
    if (s.who === 'her' && l > 0) return 'Picked for her';
    if (s.who === 'him' && l < 0) return 'Picked for him';
    for (var i = 0; i < s.vibes.length; i++) {
      if (vibeHit(p, s.vibes[i])) return VIBES.filter(function (v) { return v[0] === s.vibes[i]; })[0][1];
    }
    return s.who === 'gift' ? 'Crowd-pleaser' : 'Best seller';
  }
  /* the collection's products with tags (kept for the visit), ranked by the saved answers */
  function list(collectionSlug) {
    var ck = 'pmint_' + collectionSlug;
    try { var c = sessionStorage.getItem(ck); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) { e = 0; }
    return fetch('/collections/' + collectionSlug + '/products.json?limit=250').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var out = ((d && d.products) || []).map(function (p, i) {
        var v = (p.variants || [])[0] || {};
        return { h: p.handle, title: p.title, tags: p.tags || [], price: v.price, avail: (p.variants || []).some(function (x) { return x.available; }), img: p.images && p.images[0] && p.images[0].src, i: i };
      });
      try { sessionStorage.setItem(ck, JSON.stringify(out)); } catch (e) { e = 0; }
      return out;
    }).catch(function () { return []; });
  }
  function ranked(collectionSlug) {
    return list(collectionSlug).then(function (all) {
      return all.filter(function (p) { return p.avail; }).map(function (p) { return { p: p, s: score(p, p.i) }; }).sort(function (a, b) { return b.s - a.s || a.p.i - b.p.i; });
    });
  }

  /* score a card straight from the page: tags travel in data-tags, the name is on the card */
  function scoreEl(el, rank, bias) {
    var tags = String(el.getAttribute('data-tags') || '').split(',').filter(Boolean);
    var t = el.getAttribute('data-title') || (el.querySelector('.pmc-ct') || el.querySelector('.grid-view-item__title') || {}).textContent || el.getAttribute('aria-label') || '';
    var p = { tags: tags, title: t };
    return score(p, rank) + (bias ? bias(p, tags) : 0);
  }

  /* how many cases carry an audience tag in a collection (run it with ?pmcheck=1 on any page and read the browser console) */
  function coverage(collectionSlug) {
    return list(collectionSlug).then(function (all) {
      var c = { collection: collectionSlug, cases: all.length, her: 0, him: 0, all: 0, untagged: 0, untaggedNames: [] };
      all.forEach(function (p) { var a = aud(p); if (a) c[a]++; else { c.untagged++; if (c.untaggedNames.length < 15) c.untaggedNames.push(p.title); } });
      return c;
    });
  }
  try { if (/[?&]pmcheck=1/.test(location.search)) { var sl = slug(phone() || 'iPhone 17 Pro Max'); coverage(sl).then(function (c) { console.log('[pmIntent] audience tags in ' + sl, c); }); } } catch (e) { e = 0; }

  window.pmIntent = { scoreEl: scoreEl, aud: aud, coverage: coverage, VIBES: VIBES, PHONES: PHONES, get: get, set: set, clear: clear, has: has, phone: phone, slug: slug, score: score, why: why, lean: lean, list: list, ranked: ranked };
})();
